/**
 * @generated SignedSource<<4e636fb107b054f259bfc30179d4bd22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingDesignerItem_designer$data = {
  readonly designFirm: {
    readonly directoryProfile: {
      readonly profilePhoto: string | null;
    } | null;
    readonly name: string | null;
    readonly publicProfile: {
      readonly urlLabel: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly imageUrl: string | null;
  readonly " $fragmentType": "InteriorsLandingDesignerItem_designer";
};
export type InteriorsLandingDesignerItem_designer$key = {
  readonly " $data"?: InteriorsLandingDesignerItem_designer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingDesignerItem_designer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingDesignerItem_designer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DirectoryDesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmDirectoryProfile",
          "kind": "LinkedField",
          "name": "directoryProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePhoto",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmPublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingModuleItem",
  "abstractKey": null
};

(node as any).hash = "f0907d23cac7cc918e888eb685ded5bd";

export default node;
